
export class HeaderSwitch {
    private static instance: HeaderSwitch;
    static getInstance(): HeaderSwitch {
        if (!HeaderSwitch.instance) {
            HeaderSwitch.instance = new HeaderSwitch();
        }
        return HeaderSwitch.instance;
    }
    constructor() {
       this.init();
    }
    init(){
          const isLocalized:boolean = localStorage.getItem('dbaName') !== null;
          if(!isLocalized)
              return;
          const pageSettingsElement = document.getElementById('page-settings');
          if(!pageSettingsElement)
              return;
          const rawString = pageSettingsElement.outerHTML.split("value=")[1];
          const pageScope = rawString?.split('"pagescope":"')[1]?.split('"')[0]?.trim();
          if(isLocalized && pageScope === 'national')
            this.initalizeVDOM();

    }

    initalizeVDOM(){
        const header = document.querySelector('.header-wrapper') as HTMLElement;
        const nationaDom = document.querySelector('.brand-header') as HTMLElement;
        const localDom = document.querySelector('.brand-header-local') as HTMLElement;
        if(!nationaDom || !localDom || !header)
            return;
        this.handleDOMLoaded();
    }


private handleDOMLoaded(): void {
    const oldBrandHeader = document.querySelector(".brand-header");

    // Select the local brand header
    const newBrandHeader = document.querySelector(".brand-header-local");

    if (oldBrandHeader && newBrandHeader) {
        const clonedNewBrandHeader = newBrandHeader.cloneNode(true);
        oldBrandHeader.replaceWith(clonedNewBrandHeader);  
         //Removing the local header
         newBrandHeader.remove();
    } 
}
}




